import React, { useState } from "react";
import Style from "../../../styles/features/treinos/ExibicaoTreinoDieta.module.css";
import BlocoCard from "./BlocoCard";
import { useExerciseMedia } from "../hooks/useExerciseMedia.js";

const TreinoDiaBlocos = ({ dia, onOpenVideo }) => {
  // Resolve mídia (vídeo/thumb) da exercise_library 1x por dia — hoisteado aqui e
  // repassado a cada BlocoCard/ExerciseRow via prop (mesmo padrão dos outros renderers).
  const getMedia = useExerciseMedia();

  const blocos = (dia?.blocos || []).sort(
    (a, b) => (Number(a.ordem ?? 0) - Number(b.ordem ?? 0))
  );

  const atletaLabel = [
    dia?.athlete_profile?.level,
    dia?.athlete_profile?.gender,
  ].filter(Boolean).join(" · ");

  const totalExercicios = blocos.reduce((acc, bloco) => {
    return acc + (bloco.entries || []).reduce((a, entry) => {
      if (entry.entry_type === "circuit") return a + (entry.exercises || []).length;
      if (entry.entry_type === "exercise") return a + 1;
      return a;
    }, 0);
  }, 0);

  return (
    <div className={Style.tabItem}>
      {/* Header do dia */}
      <div className={Style.containerTreino}>
        <div className={Style.tabTitleRefeicao}>
          <h4>{dia?.nome || "Treino"}</h4>
          <p>{dia?.dia || ""}</p>
          {atletaLabel ? (
            <span style={{
              display: "inline-block",
              marginTop: 4,
              fontSize: 11,
              fontWeight: 500,
              color: "var(--color-primary)",
              background: "var(--color-accent)22",
              border: "1px solid var(--color-accent)",
              borderRadius: 99,
              padding: "2px 10px",
            }}>
              {atletaLabel}
            </span>
          ) : null}
        </div>
        <div className={Style.tabCalories}>
          <h4>{blocos.length}</h4>
          <p>Blocos</p>
        </div>
      </div>

      {/* Objetivo do dia se houver */}
      {dia?.orientacoes ? (
        <p style={{
          fontSize: 13, color: "var(--color-primary)",
          opacity: 0.7, marginBottom: 12,
        }}>
          {dia.orientacoes}
        </p>
      ) : null}

      {/* Lista de blocos */}
      <div style={{ marginTop: 8 }}>
        {blocos.map((bloco) => (
          <BlocoCard
            key={bloco.id}
            bloco={bloco}
            onOpenVideo={onOpenVideo}
            getMedia={getMedia}
          />
        ))}
      </div>
    </div>
  );
};

export default TreinoDiaBlocos;